module.exports = __webpack_public_path__ + "img/hero-sp.5c2d164a.jpg";